import { render, staticRenderFns } from "./VideoActions.vue?vue&type=template&id=5bfd24a7"
import script from "./VideoActions.vue?vue&type=script&lang=js"
export * from "./VideoActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports